<script setup>
const props = defineProps(['event']);
const eventTypes = ['NONE', 'GOOUT', 'PROGRAMS_FOR_SCHOOLS', 'PROGRAMS_ATELIERS_CHILDREN', 'GUIDED_TOURS'];

onBeforeUnmount(() => {
  if (document.querySelector('#goout')) {
    document.querySelector('#goout').removeAttribute('id');
  }
});

onMounted(() => {
  if (process.browser) {
    const goOutScript = document.createElement('script');
    goOutScript.setAttribute('src', 'https://partners.goout.net/cz-prague/ngpraguecz_new.js');
    goOutScript.async = true;
    goOutScript.onload = () => {
      console.log('GoOut script loaded');
      document.dispatchEvent(new Event('page-refreshed'));
    };
    document.body.appendChild(goOutScript);
  } else {
    console.log('GoOut script already exists');
    document.dispatchEvent(new Event('page-refreshed'));
  }

  if (process.browser && eventTypes.indexOf(props.event.reservation_type) == 1) {
    setTimeout(() => {
      document.dispatchEvent(new Event('page-refreshed'));
    }, 2000);
  }
});
</script>

<template>
  <div>
    <div v-if="eventTypes.indexOf(event.reservation_type) == 0"></div>
    <div v-if="eventTypes.indexOf(event.reservation_type) == 1">
      <div id="goout" class="goout" />
    </div>
    <ReservationFormProgramsForSchools v-if="eventTypes.indexOf(event.reservation_type) == 2" />
    <ReservationFormProgramsAteliersChildren v-if="eventTypes.indexOf(event.reservation_type) == 3" />
    <!--  <ReservationFormGuidedTours v-if="eventTypes.indexOf(event.reservation_type) == 4" /> -->
    <div v-if="eventTypes.indexOf(event.reservation_type) != 1">
      <div data-goout-forbidden />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.goout {
  margin-top: 50px;
}
</style>
